const $inject = ['$compile']

//Bind html to template just like with ng-bind="HTML", except do $compile for it also.
//For when html being bound also includes angularjs stuff like ng-click and such.
function BindHtmlCompile(compile) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            scope.$watch(() => scope.$eval(attrs.bindHtmlCompile), (value) => {
                if (typeof value === 'undefined') { //Skip if value not set yet.
                    return;
                }

                element.html(value.toString());

                scope.$evalAsync(() => {
                    compile(element.contents())(scope);
                });
            });
        }
    };
}

BindHtmlCompile.$inject = $inject

export default BindHtmlCompile